export interface ICommissions {
  carrier: string;
  insurance_type: string;
  commission: {
    [CommissionRateType.NEW]: number | [number, number];
    [CommissionRateType.RENEWAL]: number | [number, number];
  };
  tooltip?: {
    text: string;
    onlyShowFor?: CommissionRateType;
  };
}

export enum CommissionRateType {
  NEW = 'new',
  RENEWAL = 'renewal',
}

export enum Carriers {
  AMTRUST = 'AmTrust',
  ATBAY = 'At-Bay',
  ATTUNE = 'Attune',
  BERKLEY = 'Berkley Management Protection',
  BIBERK = 'biBERK',
  CNA = 'CNA',
  COTERIE = 'Coterie',
  COWBELL = 'Cowbell',
  HISCOX = 'Hiscox',
  MARKEL = 'Markel',
  NEXT = 'NEXT',
  NOW_INUSRANCE = 'NOW Insurance',
  RAINBOW = 'Rainbow',
  STATE_AUTO = 'State Auto',
  THREE = 'THREE',
  TRAVELERS = 'Travelers',
  WESTFIELD = 'Westfield',
  UTICAFIRST = 'Utica First',
}

export enum InsuranceTypes {
  ADMITTED_CYBER = 'Admitted Cyber',
  BOP = 'Business Owner’s Policy',
  CONTRACTORS_PACKAGE = 'Contractors Package',
  COMMERCIAL_AUTO = 'Commercial Auto',
  COMMERCIAL_FLOOD = 'Commercial Flood',
  COMMERCIAL_GL = 'Commercial General Liability',
  COMMERCIAL_PACKAGE = 'Commercial Package',
  COMMERCIAL_PROPERTY = 'Commercial Property',
  CRIME = 'Crime',
  CYBER = 'Cyber',
  DIRECTORS_AND_OFFICERS = 'Directors & Officers Liability',
  EPLI = 'Employment Practices Liability',
  EQUIPMENT = 'Equipment Breakdown',
  FIDUCIARY = 'Fiduciary',
  GL = 'General Liability',
  HABITATIONAL_NON_BOP = 'Apartment / Habitational (non-BOP)',
  HABITATIONAL_BUSINESSOWNER = 'Business Owner’s Habitational',
  LIFE_SCIENCES = 'Life Sciences',
  ML = 'Management Liability',
  OTHER = 'All other coverages',
  PL = 'Professional Liability',
  PROPERTY = 'Property',
  PROPERTY_MARINE = 'Property (including Inland Marine)',
  THREE = 'THREE Policy',
  UMBRELLA = 'Umbrella',
  WC = `Workers Compensation`,
  ARTISAN = 'Artisan',
}

export enum CommissionsTooltips {
  PERCENTAGE_RANGE = 'Commission varies based on policy size, state and other factors',
}

export const commissionsTableData: ICommissions[] = [
  {
    carrier: Carriers.AMTRUST,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: 0.1333,
      [CommissionRateType.RENEWAL]: 0.1333,
    },
  },
  {
    carrier: Carriers.AMTRUST,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: 0.08,
      [CommissionRateType.RENEWAL]: 0.08,
    },
  },
  {
    carrier: Carriers.ATBAY,
    insurance_type: InsuranceTypes.ADMITTED_CYBER,
    commission: {
      [CommissionRateType.NEW]: 0.1425,
      [CommissionRateType.RENEWAL]: 0.1425,
    },
  },
  {
    carrier: Carriers.ATTUNE,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: [0.09375, 0.1125],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
      onlyShowFor: CommissionRateType.RENEWAL,
    },
  },
  {
    carrier: Carriers.ATTUNE,
    insurance_type: InsuranceTypes.COMMERCIAL_FLOOD,
    commission: {
      [CommissionRateType.NEW]: 0.075,
      [CommissionRateType.RENEWAL]: 0.06,
    },
  },
  {
    carrier: Carriers.ATTUNE,
    insurance_type: InsuranceTypes.CYBER,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.ATTUNE,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.09375,
    },
  },
  {
    carrier: Carriers.ATTUNE,
    insurance_type: InsuranceTypes.PL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.09375,
    },
  },
  {
    carrier: Carriers.ATTUNE,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: [0.075, 0.105],
      [CommissionRateType.RENEWAL]: [0.06, 0.075],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.ATTUNE,
    insurance_type: InsuranceTypes.OTHER,
    commission: {
      [CommissionRateType.NEW]: 0.09375,
      [CommissionRateType.RENEWAL]: 0.09375,
    },
  },
  {
    carrier: Carriers.BERKLEY,
    insurance_type: InsuranceTypes.CRIME,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BERKLEY,
    insurance_type: InsuranceTypes.CYBER,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BERKLEY,
    insurance_type: InsuranceTypes.DIRECTORS_AND_OFFICERS,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BERKLEY,
    insurance_type: InsuranceTypes.EPLI,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BERKLEY,
    insurance_type: InsuranceTypes.FIDUCIARY,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BERKLEY,
    insurance_type: InsuranceTypes.PL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BIBERK,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BIBERK,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BIBERK,
    insurance_type: InsuranceTypes.PL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BIBERK,
    insurance_type: InsuranceTypes.UMBRELLA,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.BIBERK,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: 0.075,
      [CommissionRateType.RENEWAL]: 0.075,
    },
  },
  {
    carrier: Carriers.BIBERK,
    insurance_type: InsuranceTypes.COMMERCIAL_AUTO,
    commission: {
      [CommissionRateType.NEW]: 0.05,
      [CommissionRateType.RENEWAL]: 0.05,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: 0.135,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.COMMERCIAL_AUTO,
    commission: {
      [CommissionRateType.NEW]: 0.075,
      [CommissionRateType.RENEWAL]: 0.075,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.EQUIPMENT,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.LIFE_SCIENCES,
    commission: {
      [CommissionRateType.NEW]: 0.135,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.ML,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.PL,
    commission: {
      [CommissionRateType.NEW]: 0.135,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.PROPERTY,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.UMBRELLA,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.CNA,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: 0.15,
      [CommissionRateType.RENEWAL]: 0.075,
    },
  },
  {
    carrier: Carriers.COTERIE,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.COTERIE,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.COTERIE,
    insurance_type: InsuranceTypes.PL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.COWBELL,
    insurance_type: InsuranceTypes.CYBER,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.HISCOX,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: 0.15,
      [CommissionRateType.RENEWAL]: 0.15,
    },
  },
  {
    carrier: Carriers.HISCOX,
    insurance_type: InsuranceTypes.CYBER,
    commission: {
      [CommissionRateType.NEW]: 0.15,
      [CommissionRateType.RENEWAL]: 0.15,
    },
  },
  {
    carrier: Carriers.HISCOX,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: 0.15,
      [CommissionRateType.RENEWAL]: 0.15,
    },
  },
  {
    carrier: Carriers.HISCOX,
    insurance_type: InsuranceTypes.PL,
    commission: {
      [CommissionRateType.NEW]: 0.15,
      [CommissionRateType.RENEWAL]: 0.15,
    },
  },
  {
    carrier: Carriers.HISCOX,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: 0.15,
      [CommissionRateType.RENEWAL]: 0.15,
    },
  },
  {
    carrier: Carriers.HISCOX,
    insurance_type: InsuranceTypes.OTHER,
    commission: {
      [CommissionRateType.NEW]: 0.15,
      [CommissionRateType.RENEWAL]: 0.15,
    },
  },
  {
    carrier: Carriers.MARKEL,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: 0.135,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.MARKEL,
    insurance_type: InsuranceTypes.COMMERCIAL_PACKAGE,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.075,
    },
  },
  {
    carrier: Carriers.MARKEL,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.075,
    },
  },
  {
    carrier: Carriers.MARKEL,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: 0.09,
      [CommissionRateType.RENEWAL]: 0.06,
    },
  },
  {
    carrier: Carriers.NEXT,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: [0.105, 0.135],
      [CommissionRateType.RENEWAL]: [0.09, 0.12],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.NEXT,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: [0.105, 0.135],
      [CommissionRateType.RENEWAL]: [0.09, 0.12],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.NEXT,
    insurance_type: InsuranceTypes.PL,
    commission: {
      [CommissionRateType.NEW]: [0.105, 0.135],
      [CommissionRateType.RENEWAL]: [0.09, 0.12],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.NOW_INUSRANCE,
    insurance_type: InsuranceTypes.PL,
    commission: {
      [CommissionRateType.NEW]: 0.15,
      [CommissionRateType.RENEWAL]: 0.15,
    },
  },
  {
    carrier: Carriers.RAINBOW,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.09375,
    },
  },
  {
    carrier: Carriers.STATE_AUTO,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: [0.1125, 0.13125],
      [CommissionRateType.RENEWAL]: 0.1125,
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
      onlyShowFor: CommissionRateType.NEW,
    },
  },
  {
    carrier: Carriers.STATE_AUTO,
    insurance_type: InsuranceTypes.COMMERCIAL_AUTO,
    commission: {
      [CommissionRateType.NEW]: [0.1, 0.1125],
      [CommissionRateType.RENEWAL]: [0.08, 0.09375],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.STATE_AUTO,
    insurance_type: InsuranceTypes.COMMERCIAL_PACKAGE,
    commission: {
      [CommissionRateType.NEW]: [0.09, 0.1125],
      [CommissionRateType.RENEWAL]: [0.09, 0.1125],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.STATE_AUTO,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: [0.09, 0.15],
      [CommissionRateType.RENEWAL]: [0.075, 0.09],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.THREE,
    insurance_type: InsuranceTypes.COMMERCIAL_AUTO,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.THREE,
    insurance_type: InsuranceTypes.COMMERCIAL_PROPERTY,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.THREE,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.THREE,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.TRAVELERS,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: [0.1125, 0.135],
      [CommissionRateType.RENEWAL]: [0.09, 0.1125],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.TRAVELERS,
    insurance_type: InsuranceTypes.COMMERCIAL_AUTO,
    commission: {
      [CommissionRateType.NEW]: [0.075, 0.1125],
      [CommissionRateType.RENEWAL]: [0.075, 0.1125],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.TRAVELERS,
    insurance_type: InsuranceTypes.COMMERCIAL_PROPERTY,
    commission: {
      [CommissionRateType.NEW]: [0.1125, 0.135],
      [CommissionRateType.RENEWAL]: [0.09, 0.1125],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.TRAVELERS,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: [0.1125, 0.135],
      [CommissionRateType.RENEWAL]: [0.09, 0.1125],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.TRAVELERS,
    insurance_type: InsuranceTypes.UMBRELLA,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.TRAVELERS,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: [0.03, 0.09],
      [CommissionRateType.RENEWAL]: [0.03, 0.075],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.UTICAFIRST,
    insurance_type: InsuranceTypes.ARTISAN,
    commission: {
      [CommissionRateType.NEW]: [0.1125, 0.15],
      [CommissionRateType.RENEWAL]: [0.1125, 0.15],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.UTICAFIRST,
    insurance_type: InsuranceTypes.UMBRELLA,
    commission: {
      [CommissionRateType.NEW]: 0.1125,
      [CommissionRateType.RENEWAL]: 0.1125,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.HABITATIONAL_NON_BOP,
    commission: {
      [CommissionRateType.NEW]: 0.075,
      [CommissionRateType.RENEWAL]: 0.075,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.BOP,
    commission: {
      [CommissionRateType.NEW]: [0.0975, 0.105],
      [CommissionRateType.RENEWAL]: [0.0825, 0.09],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.HABITATIONAL_BUSINESSOWNER,
    commission: {
      [CommissionRateType.NEW]: 0.09,
      [CommissionRateType.RENEWAL]: 0.09,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.COMMERCIAL_AUTO,
    commission: {
      [CommissionRateType.NEW]: 0.09,
      [CommissionRateType.RENEWAL]: 0.075,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.CONTRACTORS_PACKAGE,
    commission: {
      [CommissionRateType.NEW]: 0.105,
      [CommissionRateType.RENEWAL]: 0.09,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.GL,
    commission: {
      [CommissionRateType.NEW]: [0.0975, 0.105],
      [CommissionRateType.RENEWAL]: [0.0825, 0.09],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.PROPERTY_MARINE,
    commission: {
      [CommissionRateType.NEW]: 0.105,
      [CommissionRateType.RENEWAL]: 0.09,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.UMBRELLA,
    commission: {
      [CommissionRateType.NEW]: 0.105,
      [CommissionRateType.RENEWAL]: 0.09,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.WC,
    commission: {
      [CommissionRateType.NEW]: [0.045, 0.0525],
      [CommissionRateType.RENEWAL]: [0.045, 0.0525],
    },
    tooltip: {
      text: CommissionsTooltips.PERCENTAGE_RANGE,
    },
  },
  {
    carrier: Carriers.WESTFIELD,
    insurance_type: InsuranceTypes.OTHER,
    commission: {
      [CommissionRateType.NEW]: 0.105,
      [CommissionRateType.RENEWAL]: 0.09,
    },
  },
];
